var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 91,
    viewBox: "0 0 86 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9673L42.0082 0L85.1473 14.7012L78.1626 70.2798L42.0082 90.3027L6.41931 70.5459L0 14.9673Z",
    fill: "#E23237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1474 14.7012L42.0083 0V90.3027L78.1627 70.3131L85.1474 14.7012Z",
    fill: "#B52E31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0746 10.5436L15.8984 68.783L25.6771 68.6167L30.9323 55.4787H42.1078H42.1411H54.4143L60.1684 68.783L69.5146 68.9493L42.0746 10.5436ZM42.1411 29.2028L50.9884 47.6958H42.507H42.0746H34.3581L42.1411 29.2028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.8c9f7ccec1ab9b70ff6a4c0f56dd240e.svg";
export { ForwardRef as ReactComponent };